module.exports = __webpack_public_path__ + "img/logo.6255ad0a.svg";